export const apiKey = "615dd442a6a8a27b9a34500791c835bf";

export const cities = [
  {
    id: 1560349,
    name: "Yên Bái",
  },
  {
    id: 1562414,
    name: "Vũng Tàu",
  },
  {
    id: 1562693,
    name: "Vĩnh Long",
  },
  {
    id: 1562798,
    name: "Vinh",
  },
  {
    id: 1563287,
    name: "Tuyên Quang",
  },
  {
    id: 1566083,
    name: "Tp.HCM",
  },
  {
    id: 1566166,
    name: "Thanh Hóa",
  },
  {
    id: 1566346,
    name: "Thái Bình",
  },
  {
    id: 1568770,
    name: "Quảng Ngãi",
  },
  {
    id: 1571968,
    name: "Ninh Bình",
  },
  {
    id: 1573517,
    name: "Nam Định",
  },
  {
    id: 1572151,
    name: "Nha Trang",
  },
  {
    id: 1576303,
    name: "Lào Cai",
  },
  {
    id: 1576633,
    name: "Lạng Sơn",
  },
  {
    id: 1580142,
    name: "Hưng Yên",
  },
  {
    id: 1580240,
    name: "Huế",
  },
  {
    id: 1580541,
    name: "Hội An",
  },
  {
    id: 1580830,
    name: "Hòa Bình",
  },
  {
    id: 1581047,
    name: "Hà Tĩnh",
  },
  {
    id: 1581130,
    name: "Hà Nội",
  },
  {
    id: 1581298,
    name: "Hải Phòng",
  },
  {
    id: 1581326,
    name: "Hải Dương",
  },
  {
    id: 1581349,
    name: "Hà Giang",
  },
  {
    id: 1584071,
    name: "Đà Lạt",
  },
  {
    id: 1586185,
    name: "Cao Bằng",
  },
  {
    id: 1586203,
    name: "Cần Thơ",
  },
  {
    id: 1586443,
    name: "Cà Mau",
  },
  {
    id: 1591449,
    name: "Bắc Ninh",
  },
  {
    id: 1587976,
    name: "Bến Tre",
  },
  {
    id: 1591527,
    name: "Bắc Giang",
  },
  {
    id: 1591538,
    name: "Bắc Cạn",
  },
  { id: 1591474, name: "Bạc Liêu" },
];
